import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { bindActionCreators } from "redux";
import formActionsImp from "../../../Actions/formActions";
import { JsonTreeEditor } from "./JsonTreeEditor";

export function AppConfigForm({ config, onEditingStateChange }) {
    const dispatch = useDispatch();
    const formActions = bindActionCreators(formActionsImp, dispatch);
    const form = useSelector((state) => state.FormReducer.forms[config.name]);

    if (!form) return null;

    const value = form.data?.value;
    const schema = form.data?.schema;
    const errors = form.fieldErrorFlags;

    const onChange = (newValue, changedPath) => {
        formActions.changeMultiFormField(form, "value", newValue);
        if (changedPath && errors && errors[changedPath]) {
            const { [changedPath]: _, ...rest } = errors;
            formActions.setFormValidity(form.id, rest);
        }
    };

    return (
        <form className="skynet-form">
            <fieldset className="d-flex flex-column gap-16">
                <JsonTreeEditor
                    value={value}
                    schema={schema}
                    errors={errors}
                    onChange={onChange}
                    onEditingStateChange={onEditingStateChange}
                />
            </fieldset>
        </form>
    );
}
